import { Location } from "@/types/general";
import { locationSlimToOption } from "@helpers/utils";
import { internalApiSlice, transformResponse } from "@redux/api/internalApiSlice";

const locationsApi = internalApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getLocations: builder.query<Location.Merged[], void>({
            query: () => ({
                url: `location?slim=1`,
            }),
            transformResponse: (response) => {
                const data = transformResponse(response);
                return data.map(locationSlimToOption).flat();
            },
            providesTags: [{ type: "Location", id: "LIST" }],
        }),

        getModuleLocations: builder.query<Location.Merged[], string>({
            query: (module) => ({
                url: `${module}/location`,
            }),
            transformResponse: (response) => {
                const data = transformResponse(response);
                return data.map(locationSlimToOption).flat();
            },
            providesTags: [{ type: "Location", id: "LIST" }],
        }),

        getLocationsNested: builder.query<Location.Slim[], void>({
            query: () => ({
                url: `location?slim=1`,
                ignoreDatesParsing: ["name"],
            }),
            transformResponse,
            providesTags: [{ type: "Location", id: "LIST" }],
        }),

        getModuleLocationsNested: builder.query<Location.Slim[], string>({
            query: (module) => ({
                url: `${module}/location`,
                ignoreDatesParsing: ["name"],
            }),
            transformResponse,
            providesTags: [{ type: "Location", id: "LIST" }],
        }),

        createLocation: builder.mutation<Location.Extended, Location.DTO.CreateUpdate>({
            query: (body) => ({
                url: `location`,
                method: "POST",
                data: body,
            }),
            transformResponse,
            invalidatesTags: [{ type: "Location", id: "LIST" }],
        }),

        updateLocation: builder.mutation<
            Location.Extended,
            { id: number } & Location.DTO.CreateUpdate
        >({
            query: ({ id, ...body }) => ({
                url: `location/${id}`,
                method: "PUT",
                data: body,
            }),
            transformResponse,
            invalidatesTags: (result, error, arg) => [{ type: "Location", id: arg.id }],
        }),
    }),
});

export const {
    useGetLocationsQuery,
    useGetModuleLocationsQuery,
    useGetLocationsNestedQuery,
    useGetModuleLocationsNestedQuery,
    useCreateLocationMutation,
    useUpdateLocationMutation,
} = locationsApi;
